import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild, AfterViewInit, AfterContentInit } from '@angular/core';

/**
 * Component for add a load more button and show or hide content on click based on max-height.
 *
 * @export
 * @class SeeMoreComponent
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-see-more',
  templateUrl: './see-more.component.html',
  styleUrls: ['./see-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeeMoreComponent implements AfterViewInit, AfterContentInit {

  /**
   * Value for check if the panel is expanded.
   *
   * @memberof SeeMoreComponent
   */
  opened = false;

  /**
   * Html element to scroll to on see less press.
   *
   * @type {HTMLElement}
   * @memberof SeeMoreComponent
   */
  @Input() elementToScroll: HTMLElement;

  /**
   * An Input for define the max height of block.
   *
   * @type {number}
   * @memberof SeeMoreComponent
   */
  @Input() maxHeightPx: number = 100;

  /**
   * The reference for the content elements inside this component..
   *
   * @memberof SeeMoreComponent
   */
  @ViewChild("content", { static: true, read: false }) content;

  constructor(protected chg: ChangeDetectorRef) { }


  /**
   * Getter for calculate the px in string.
   *
   * @readonly
   * @memberof SeeMoreComponent
   */
  get heightInPixel() {
    return `${this.maxHeightPx}px`
  }

  /**
   * {@inheritdoc}
   *
   * @memberof SeeMoreComponent
   */
  ngAfterViewInit(): void {
    // Detect changes for know the height of ng-content.
    this.chg.detectChanges();
  }

  /**
   * {@inheritdoc}
   *
   * @memberof SeeMoreComponent
   */
  ngAfterContentInit(): void {

    //  We need a timeout to allow the dom to calculate the offset height and set the state.
    setTimeout(() => {
      if (this.content.nativeElement.offsetHeight < this.content.nativeElement.scrollHeight) {
        this.opened = false;
      } else {
        this.opened = true;
      }
      this.chg.detectChanges();
    }
      , 500)
  }

  /**
   * Method to stop to the top on press less.
   *
   * @param {HTMLElement} el The html element.
   * @memberof SeeMoreComponent
   */
  scroll(el: HTMLElement) {
    this.elementToScroll ? this.elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' }) :
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /**
   * A method to expand the container.
   *
   * @param {HTMLElement} content The content element passed as ref.
   * @memberof SeeMoreComponent
   */
  expand(content: HTMLElement) {
    content.style['max-height'] = (content.scrollHeight + 10).toString() + 'px';
    this.opened = true;
    this.chg.detectChanges();
  }

  /**
   * A method to close the container.
   *
   * @memberof SeeMoreComponent
   */
  close() {
    this.opened = false;
  }
}
